import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import appPlusGiftImg from 'assets/images/cms/gift-cards/app-plus-gift.png'
import checkoutImg from 'assets/images/gift-cards/checkout.png'
import saveImg from 'assets/images/gift-cards/save.png'
import scanImg from 'assets/images/gift-cards/scan.png'
import { buildTranslate } from 'locales'
import React from 'react'
import { Col, Row } from 'react-bootstrap-five'

const t = buildTranslate('gift_cards.empty_state')

const EmptyState = () => {
  const [css] = useStyletron()

  const handleContactUs = () => {
    window.open('mailto:success@thanx.com', '_blank')
  }

  const handleLearnMore = () => {
    window.open(
      'https://help.thanx.com/hc/en-us/articles/36015721227159-Gift-Cards-via-Valutec-integration',
      '_blank'
    )
  }

  return (
    <div>
      <Text.Header3 tag="div" className="mb-s text-left">
        {t('title')}
      </Text.Header3>

      <Text.BodyText3 color="grey70" className="mb-xl text-left">
        {t('subtitle')}
      </Text.BodyText3>

      <Row className="mt-xl mb-xl">
        <Col xs={4} className="d-flex justify-content-center">
          <img
            src={checkoutImg}
            alt="Gift card example 1"
            className={css({
              maxWidth: '100%',
              height: 'auto',
              borderRadius: '8px',
            })}
          />
        </Col>
        <Col xs={4} className="d-flex justify-content-center">
          <img
            src={scanImg}
            alt="Gift card example 2"
            className={css({
              maxWidth: '100%',
              height: 'auto',
              borderRadius: '8px',
            })}
          />
        </Col>
        <Col xs={4} className="d-flex justify-content-center">
          <img
            src={saveImg}
            alt="Gift card example 3"
            className={css({
              maxWidth: '100%',
              height: 'auto',
              borderRadius: '8px',
            })}
          />
        </Col>
      </Row>

      <Text.BodyText3 color="grey70" className="text-left">
        {t('once_connected')}
      </Text.BodyText3>

      <div className="mt-xl p-m grey-20-bkg rounded">
        <div className="mb-s">
          <img
            src={appPlusGiftImg}
            alt="Gift card info"
            className={css({
              maxHeight: '24px',
              width: 'auto',
            })}
          />
        </div>
        <Text.Header4 tag="div" className="mb-xs">
          {t('info_section.title')}
        </Text.Header4>
        <Text.BodyText3 color="grey70" className="mb-l">
          {t('info_section.subtitle')}
        </Text.BodyText3>
        <div className="mt-s d-flex justify-content-end">
          <Button
            onClick={handleLearnMore}
            type="button"
            kind="secondary"
            className="mr-s"
          >
            {t('info_section.learn_button')}
          </Button>
          <Button onClick={handleContactUs} type="button">
            {t('info_section.contact_button')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EmptyState
